import { type ReactNode } from 'react';

import { Footer } from './footer';
import { Header } from './header';

import { ScrollToTop } from '@/components/scroll-to-top';
import { CookieBanner } from '@/features/cookie-consent/cookie-banner';
import { CompareBar } from '@/features/engagement/compare-bar';

/** Shell for public-facing pages: skip link, sticky header, footer, compare
 *  bar, cookie-consent banner. */
export function PublicLayout({ children }: { children: ReactNode }) {
  return (
    <div className="flex min-h-screen flex-col">
      <ScrollToTop />
      <a href="#main" className="skip-link">
        Skip to content
      </a>
      <Header />
      {/* `min-h` (not just `flex-1`) so the footer always starts at or below the
          fold, whatever is inside. Otherwise the footer paints partway up the
          first screen and then jumps as content resolves — down on a long page,
          UP on a short one (the compare page's empty state). Flooring main at a
          viewport removes both directions at once; it was the largest layout
          shift in the app. */}
      <main
        id="main"
        className="flex-1 min-h-[calc(100vh-var(--header-offset))]"
      >
        {children}
      </main>
      <Footer />
      <CompareBar />
      <CookieBanner />
    </div>
  );
}
